
import { ArticleData } from './types';

// Additional articles previously defined in index.ts
export const additionalArticles: ArticleData[] = [
  {
    id: 1000,
    slug: "user-behaviour-sequence-modelling",
    title: "In-session adaptation via User behaviour Sequence modelling",
    description: "Learn about using sequence modeling to adapt recommendations based on user behavior in real-time within a single session.",
    author: "HelloML Team",
    publishDate: "2025-05-01",
    category: "ML System Design",
    readTime: "10 min read",
    readCount: 0,
    likeCount: 0,
    tags: ["recommendation systems", "user behavior", "sequence modeling"],
    isPremium: false,
    featured: true,
    imageUrl: "/src/data/html-content/images/image1.png",
    contentType: "html"
  },
  {
    id: 1001,
    slug: "harmful-content-detection",
    title: "Design a Harmful Content Detection System",
    description: "Learn how to design an effective system for detecting harmful content using machine learning algorithms.",
    author: "HelloML Team",
    publishDate: "2025-05-04",
    category: "ML System Design",
    readTime: "12 min read",
    readCount: 0,
    likeCount: 0,
    tags: ["content moderation", "safety", "ml systems"],
    isPremium: false,
    featured: true,
    contentType: "html"
  }
];
